import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-alaska-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./alaska-state-form.component.html",
  styleUrl: "./alaska-state-form.component.scss",
})
export class AlaskaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
